// extracted by mini-css-extract-plugin
var _1 = "RegistrationFormFields-modulebutton__KAkxi";
var _2 = "RegistrationFormFields-moduleformFields__adihP FormFieldsContainer-moduleFormFieldsContainer__u1JJu";
export { _1 as "button", _2 as "formFields" }
